module.exports = "/wp-content/plugins/farmacy/assets/js/images/license-a2f5f2a2315281ddb57c26505e7f7d7d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/entry-flow/age-gate/img/license.png
 ** module id = 780
 ** module chunks = 1 39 104
 **/